import { ZERO_VALUE, ONE_VALUE } from "@utils/constants";
import { FIRST_INDEX, MODULO_INDEX } from "./constants";

export const transformTenantData = (
  tenantOrgs,
  language,
  externalCodeTag = "ORG_EXTERNAL_CODE",
  separator = " | "
) => {
  const parentNode = tenantOrgs.find((record) => {
    return record.Level === ZERO_VALUE;
  });

  const firstChilds = tenantOrgs
    .filter((record) => {
      return record.Level !== ZERO_VALUE;
    })
    .filter((record) => record.ParentOrgId === parentNode.OrgId);

  const transformedData = {
    id: parentNode.OrgId.toString(),
    data: {
      name: parentNode.OrgDetails.filter((detail) => {
        return detail.LanguageCode === language;
      })[FIRST_INDEX]?.ShortName,
    },
    children: firstChilds.map((org) => ({
      id: org.OrgId.toString(),
      data: {
        name:
          org.OrgDetails.find((detail) => detail.LanguageCode === language)
            .ShortName +
          "<br>" +
          `(${org.OrgAttributes.filter((attribute) => {
            return attribute.AttributeTypeTag === externalCodeTag;
          })
            .map((attribute, index) => {
              return (
                attribute.AttributeValue +
                (index !== org.OrgAttributes.length - ONE_VALUE ? separator : "")
              );
            })
            .join("")})`,
      },
      children: [
        ...tenantOrgs
          .filter((record) => record.ParentOrgId === org.OrgId)
          .map((branch, index) => {
            const currentChild = tenantOrgs.filter(
              (record) => record.ParentOrgId === org.OrgId
            )[FIRST_INDEX];
            return {
              id: branch.OrgId.toString(),
              data: {
                name:
                  branch.OrgDetails.find(
                    (detail) => detail.LanguageCode === language
                  ).ShortName +
                  "<br>" +
                  `(${branch.OrgAttributes.filter((attribute) => {
                    return attribute.AttributeTypeTag === externalCodeTag;
                  })
                    .map((attribute, index) => {
                      return (
                        attribute.AttributeValue +
                        (index !== branch.OrgAttributes.length - ONE_VALUE
                          ? separator
                          : "")
                      );
                    })
                    .join("")})`,
              },
              children: currentChild.OrgDevices.map((terminal) => ({
                id: terminal.DeviceId.toString(),
                data: {
                  name: terminal.DeviceName,
                },
              })),
            };
          }),
      ],
    })),
  };
  const treeTransformedData = {
    id: parentNode.OrgId.toString(),
    data: {
      fontSize: "20px",
      name: parentNode.OrgDetails.filter((detail) => {
        return detail.LanguageCode === language;
      })[FIRST_INDEX]?.ShortName,
      tooltip: parentNode.OrgAttributes.map((singleAttribute, index) => {
        return `${
          singleAttribute.AttributeTypeDetails.find(
            (detail) => detail.LanguageCode === language
          )?.Name
        }: ${singleAttribute.AttributeValue}`;
      }).join("</br>"),
    },
    options: {
      nodeBGColor: "#03256C",
      nodeBGColorHover: "#03256C",
    },
    children: firstChilds.map((org) => ({
      id: org.OrgId.toString(),
      data: {
        fontSize: "18px",
        name:
          org.OrgDetails.find((detail) => detail.LanguageCode === language)
            .ShortName +
          "<br>" +
          `(${org.OrgAttributes.filter((attribute) => {
            return attribute.AttributeTypeTag === externalCodeTag;
          })
            .map((attribute, index) => {
              return (
                attribute.AttributeValue +
                (index !== org.OrgAttributes.length - ONE_VALUE ? separator : "")
              );
            })
            .join("")})`,
        // tooltip: "tooltip level 1",
      },
      options: {
        nodeBGColor: "#2541B2",
        nodeBGColorHover: "#2541B2",
      },
      children: [
        ...tenantOrgs
          .filter((record) => record.ParentOrgId === org.OrgId)
          .map((branch, index) => {
            const currentChild = tenantOrgs.filter(
              (record) => record.ParentOrgId === org.OrgId
            )[FIRST_INDEX];
            const terminals = branch.OrgDevices.map((terminal) => ({
              id: terminal.DeviceId.toString(),
              data: {
                name: terminal.DeviceName,
                fontSize: "13px",
                nodeBGColor: "#06BEE1",
                nodeBGColorHover: "#06BEE1",
                tooltip: terminal.DeviceStatusDetails.find(
                  (detail) => detail.LanguageCode === language
                )?.StatusName,
              },
              options: {
                nodeBGColor: "#06BEE1",
                nodeBGColorHover: "#06BEE1",
              },
            }));

            const distributeTerminals = (terminals) => {
              const distributed = [];
              let currentParent = null;

              terminals.forEach((terminal, index) => {
                if (index % MODULO_INDEX === ZERO_VALUE) {
                  currentParent = {
                    id: terminal.id,
                    data: terminal.data,
                    options: terminal.options,
                    children: [],
                  };
                  distributed.push(currentParent);
                }
                let currentChild = currentParent;
                while (!!currentChild.children?.length) {
                  currentChild = currentChild.children[FIRST_INDEX];
                }
                if (!currentChild.children) {
                  currentChild.children = [];
                }
                const terminalExists = currentChild.id === terminal.id;

                if (!terminalExists) {
                  currentChild.children.push(terminal);
                }
              });
              return distributed;
            };

            return {
              id: branch.OrgId.toString(),
              data: {
                nodeBGColor: "#1768AC",
                nodeBGColorHover: "#1768AC",
                fontSize: "16px",
                name:
                  branch.OrgDetails.find(
                    (detail) => detail.LanguageCode === language
                  ).ShortName +
                  "<br>" +
                  `(${branch.OrgAttributes.filter((attribute) => {
                    return attribute.AttributeTypeTag === externalCodeTag;
                  })
                    .map((attribute, index) => {
                      return (
                        attribute.AttributeValue +
                        (index !== branch.OrgAttributes.length - ONE_VALUE
                          ? separator
                          : "")
                      );
                    })
                    .join("")})`,
                // tooltip: "tooltip level 2",
              },
              options: {
                nodeBGColor: "#1768AC",
                nodeBGColorHover: "#1768AC",
              },
              children: distributeTerminals(terminals),
            };
          }),
      ],
    })),
  };

  return {
    transformedData,
    treeTransformedData,
  };
};
